import styled from '@emotion/styled';

export const CenteredGrid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
